import { createRouter, createWebHistory } from 'vue-router';
import cookieManager from '@/utils/cookieManager';
import store from '@/store/index';

function requireCookie(to, from, next) {
  const accessToken = cookieManager.get('accessToken');
  if (accessToken == null) {
    next({ name: 'Login' });
  } else if (!cookieManager.hasOtpVerified()) {
    next({ name: 'VerifyOTP' });
  } else {
    next();
  }
}

function requireLoginCookie(to, from, next) {
  const accessToken = cookieManager.get('accessToken');
  if (accessToken == null) {
    next();
  } else {
    next({ name: cookieManager.hasOtpVerified() ? 'HomeView' : 'VerifyOTP' });
  }
}

function requirePendingOtp(to, from, next) {
  const accessToken = cookieManager.get('accessToken');
  if (accessToken == null) {
    next({ name: 'Login' });
  } else if (cookieManager.hasOtpVerified()) {
    next({ name: 'HomeView' });
  } else {
    next();
  }
}


const routes = [
  {
    path: '/',
    name: 'Start',
    component: () => import('@/views/auth/LoginView.vue'),
    beforeEnter: requireLoginCookie
  },
  {
    path: '/home',
    name: 'HomeView',
    component: () => import('@/views/HomeView.vue'),
    beforeEnter: requireCookie
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/LoginView.vue'),
  },
  {
    path: '/verify-otp',
    name: 'VerifyOTP',
    component: () => import('@/views/auth/VerifyOTP.vue'),
    beforeEnter: requirePendingOtp
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/auth/ForgotPassword.vue'),
  },
  {
    path: '/forgot-password/:token',
    name: 'ForgotPasswordConfirm',
    component: () => import('@/views/auth/ForgotPasswordConfirm.vue'),
    props: true
  },
  {
    path: '/update-expired-password/:token/',
    name: 'UpdateExpiredPassword',
    component: () => import('@/views/auth/UpdateExpiredPassword.vue'),
    props: true
  },
  {
    path: '/check-email',
    name: 'CheckEmail',
    component: () => import('@/views/CheckEmail.vue'),
  },
  {
    path: '/inbox',
    name: 'Inbox',
    component: () => import('@/views/InboxView.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/user-profile',
    name: 'UserProfile',
    component: () => import('@/views/UserProfile.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/admin',
    name: 'AdminView',
    component: () => import('@/views/AdminView.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/audit-users',
    name: 'AuditUsers',
    component: () => import('@/views/audits/AuditUsers.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/audit-files',
    name: 'AuditDocuments',
    component: () => import('@/views/audits/AuditDocuments.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/audit-events',
    name: 'AuditEvents',
    component: () => import('@/views/audits/AuditEvents.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/files',
    name: 'DocumentList',
    component: () => import('@/views/files/DocumentList.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/files/:id',
    name: 'DocumentItem',
    component: () => import('@/views/files/DocumentItem.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/files/upload',
    name: 'UploadFiles',
    component: () => import('@/views/files/UploadFiles.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/files/classification',
    name: 'DocumentClassification',
    component: () => import('@/views/files/DocumentClassification.vue'),
    beforeEnter: requireCookie,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'HomeView' },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// eslint-disable-next-line
router.beforeEach((to, from, next) => {
  document.title = 'Clinic Box';
  store.dispatch('updateActiveRoute', to.path);
  next();
});

export default router;
